import { render } from "./VabeneSupplementList.vue?vue&type=template&id=0f62133b&ts=true"
import script from "./VabeneSupplementList.vue?vue&type=script&lang=ts"
export * from "./VabeneSupplementList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__